<template>
  <div class="innerBox">
    <h1>Master Data - Mobil Pelanggan</h1>

    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox">
        <div class="col row">
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" v-on:keyup.enter="vue_universal_table.update++"  class="form-control" placeholder="Ketik teks" style="height: 38px;" v-model="filter.search">
          </div>
          <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    <vue-universal-table
      :api_url="'/api/v1/masterData/customer_car'"
      :filter="filter"
      :special_buttons="vue_universal_table.special_buttons"
      :buttons="vue_universal_table.buttons"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      @onBuatBaru="modal.add = true"
      @onEdit="editObj"
      @onDelete="deleteObj"
    ></vue-universal-table>

    <new-customer-car
      v-if="modal.add"
      @closeModal="modal.add = false"
      @updateTable="vue_universal_table.update++"
    ></new-customer-car>

    <edit-customer-car
      v-if="modal.edit"
      :editObject="editObject"
      @closeModal="modal.edit = false"
      @updateTable="vue_universal_table.update++"
    ></edit-customer-car>
  </div>
</template>

<script>
  import newCustomerCar from './children/newCustomerCar'
  import editCustomerCar from './children/editCustomerCar'

  export default {
    data () {
      return {
        mobile : this.isMobile(),
        modal : {
          add : false,
          edit : false
        },
        filter : {
          search : ''
        },
        editObject : null,
        vue_universal_table : {
          special_buttons : ['buatBaru'],
          buttons : [
            {
              title : "Edit",
              class : "btn-outline-primary fas fa-edit",
            },
            {
              title : "Delete",
              variable : "chassis_number",
              class : "btn-outline-danger fas fa-times",
            }
          ],
          fields : [
            {
              title : "Nomor Rangka",
              variable : "chassis_number"
            },
            {
              title : "Nomor Mesin",
              variable : "engine_number"
            },
            {
              title : "Nama Pemilik",
              variable : "customer_name"
            },
            {
              title : "Tipe Mobil",
              variable : "car_name"
            },
            {
              title : "Warna Mobil",
              variable : "car_color_name"
            },
            {
              title : "Nomor Polisi",
              variable : "registration"
            },
            {
              title : "KM Kunjungan Terakhir",
              variable : "last_km"
            }
          ],
          update : 0
        }
      }
    },
    components : {
      newCustomerCar,
      editCustomerCar,
    },
    mounted () {

    },
    methods : {
      editObj(obj){
        this.editObject = JSON.parse(obj);
        this.modal.edit = true;
      },
      deleteObj(chassis_number){
        this.$http.delete(`/api/v1/masterData/customer_car/${chassis_number.replace(/"/g, "")}`)
        .then((resp)=>{
          this.$store.dispatch('triggerAlert', [true, ['Mobil pelanggan telah berhasil dihapus']])
          this.vue_universal_table.update++;
        })
        .catch((err)=>{
          console.log(err);
        })
      },
    }
  }
</script>

<style scoped>
  .pt20{
    padding-top : 20px;
  }
</style>